/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.account" placeholder="输入账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="userAddress" label="账号地址" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="goodName" label="商品名称" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="goodNum" label="商品数量" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="allAmount" label="总价" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="address" label="地址" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.address}}</div>
          <div>{{scope.row.info}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="收货人" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="电话号码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="wuNum" label="物流单号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="logTime" label="时间" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.logTime | timeStamp }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.status == 0?'待付款':scope.row.status == 1?'待发货':scope.row.status == 2?'待确认':scope.row.status == 3?'已取消':'已完成'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" :disabled="scope.row.status != 1" @click="handleEdit(scope.$index, scope.row)">发货</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" :width="dialogWidth" @click="closeDialog('editForm')">
      <el-form :label-width="labelWidth" :model="editForm" ref="editForm">
        <el-form-item label="物流单号">
          <el-input size="small" v-model="editForm.cash" auto-complete="off" placeholder="请输入物流单号"></el-input>
        </el-form-item>
        <el-form-item label="物流公司">
          <el-select
            v-model="editForm.wuId"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.id"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('add')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, exOrderSet, OrderDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import wuliu from './wuliu.json'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '更新物流',
      payType: [
        { key: '请选择', value: 0 },
        { key: '现金', value: 1 },
        { key: '支付宝', value: 2 },
        { key: '微信', value: 3 },
        { key: 'POS通', value: 4 },
        { key: '闪付', value: 5 },
        { key: 'POS通C扫B', value: 6 },
        { key: '银联二维码', value: 8 },
        { key: '会员余额支付', value: 9 }
      ],
      options: [],
      payway: [
        { key: '请选择', value: 0 },
        { key: '初始化', value: 1 },
        { key: '已支付', value: 2 },
        { key: '出货成功', value: 3 },
        { key: '出货失败', value: 4 },
        { key: '订单超时', value: 5 },
        { key: '退款初始化', value: 11 },
        { key: '退款进行中', value: 12 },
        { key: '退款成功', value: 13 },
        { key: '退款失败', value: 14 },
        { key: '订单处理中', value: 10 }
      ],
      editForm: {
        orderId: '',
        cash: '',
        wuId: ''
      },
      searchValue: '',
      formInline: {
        page: 1,
        limit: 10,
        account: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      dialogWidth: '50%',
      labelWidth: '120px',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    
    this.getdata(this.formInline)
  },
  mounted () {
    
  },
  filters: {
    timeStamp: function(val) {
      if (val == 0) {
        return '--';
      } else {
        let value = val * 1000;
        var date = new Date();
        date.setTime(value);
        var month = date.getMonth() + 1;
        var hours = date.getHours();
        if (hours < 10)
          hours = "0" + hours;
        var minutes = date.getMinutes();
        if (minutes < 10)
          minutes = "0" + minutes;
        var time = month + "-" + date.getDate() +
          " " + hours + ":" + minutes;
        return time;
      }
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true
      OrderList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.num
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      console.log()
      if(document.body.clientWidth < 400) {
        this.dialogWidth = '85%';
        this.labelWidth = '80px';
      } else{
        this.dialogWidth = '50%';
        this.labelWidth = '120px';
      }
      this.editFormVisible = true
      this.editForm.orderId = row.id
    },
    // 编辑、增加页面保存方法
    submitForm() {
      this.loading = true
      exOrderSet(this.editForm)
        .then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.success) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '操作成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    remoteMethod(query) {
      if(query !== '') {
        this.options = wuliu.filter((item)=>{
          return item.id.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
      } else{
        this.options = []
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue